
import select2 from "select2/dist/js/select2.full"
// It must be called before using
// https://stackoverflow.com/a/76429905/838346
select2()
